// extracted by mini-css-extract-plugin
export var root = "ThemeSentinel-module--root--d605f";